import React from 'react';

interface Props {
  volume: number;
}

export default function Volume({volume}: Props) {
  const showFirst = volume > 0;
  const showSecond = volume > 40;
  const showThird = volume > 80;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      viewBox="0 0 16 12"
    >
      <g fill="#646464">
        <path d="M1.073 6.966h2.04L5.549 9.36c.339.315.92.09.92-.355V.996c0-.445-.581-.67-.92-.355L3.14 2.966H1.073c-.296 0-.538.225-.538.5v3c0 .28.242.5.538.5z" />
        {showFirst && (
          <path d="M7.61 6.768a.57.57 0 00.762 0c.508-.472.788-1.1.788-1.768a2.4 2.4 0 00-.788-1.768.568.568 0 00-.762 0 .475.475 0 000 .707c.306.284.474.66.474 1.061 0 .4-.168.778-.474 1.061a.475.475 0 000 .707z" />
        )}
        {showSecond && (
          <path d="M9.895 1.818a.568.568 0 00-.761 0 .475.475 0 000 .707c1.47 1.365 1.47 3.585 0 4.95a.475.475 0 000 .707c.21.195.55.195.761 0 1.89-1.754 1.89-4.61 0-6.364z" />
        )}
        {showThird && (
          <path d="M11.418.404a.568.568 0 00-.761 0 .475.475 0 000 .707C11.773 2.148 12.389 3.529 12.389 5c0 1.471-.615 2.852-1.732 3.89a.475.475 0 000 .706c.21.195.55.196.761 0 1.32-1.225 2.047-2.858 2.047-4.596s-.727-3.37-2.047-4.596z" />
        )}
      </g>
    </svg>
  );
}
